export default __webpack_public_path__ + "static/media/mission_bg.45086b23.png";